"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsPageContainer() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Page Container
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A responsive container that constrains content width and provides consistent padding.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/page-container" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Usage</CardTitle>
              <CardDescription>Wraps page content with max-width constraints</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="bg-muted/50 rounded-lg p-4 font-mono text-sm overflow-x-auto">
            <code className="block">{"import { PageContainer } from \"@/registry/new-york/ui/page-container\";"}</code>
            <code className="block mt-4">{"<PageContainer size=\"lg\">"}</code>
            <code className="block pl-4">{"<h1>Page Title</h1>"}</code>
            <code className="block pl-4">{"<p>Page content goes here...</p>"}</code>
            <code className="block">{"</PageContainer>"}</code>
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Default</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">size</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">"sm" | "md" | "lg" | "xl" | "full"</td>
                <td className="py-2 font-mono text-xs">"lg"</td>
                <td className="py-2 text-muted-foreground">Maximum width constraint</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">className</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 font-mono text-xs">-</td>
                <td className="py-2 text-muted-foreground">Additional CSS classes</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Sizes</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Size</th>
                <th className="text-left py-2 font-semibold">Max Width</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">sm</td>
                <td className="py-2 text-muted-foreground">640px</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">md</td>
                <td className="py-2 text-muted-foreground">768px</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">lg</td>
                <td className="py-2 text-muted-foreground">1024px</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">xl</td>
                <td className="py-2 text-muted-foreground">1280px</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">full</td>
                <td className="py-2 text-muted-foreground">100%</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
